export enum PaymentType {
  CASH = 'cash',
  ONLINE_PAYMENT = 'online-payment',
  BANK_TRANSFER = 'bank-transfer'
}
